var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 56,
    fill: "#FEF6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 32L114 32",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 82L17 82",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106 39L112 39",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 89L15 89",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121 32H125",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5382 55.8265H54.579L52.449 52.3979L51.72 52.9219V55.8265H50V47.6936H51.72V51.4183C51.8339 51.2589 51.9478 51.0994 52.0617 50.9399C52.1756 50.7805 52.2895 50.621 52.4034 50.4615L54.6018 47.6936H56.5154L53.6791 51.293L56.5382 55.8265Z",
    fill: "#E9688A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5382 55.8265L59.2954 47.6595H61.4026L64.1705 55.8265H62.3139L60.7875 50.5527C60.7496 50.4236 60.704 50.2603 60.6509 50.0629C60.5977 49.8654 60.5445 49.6642 60.4914 49.4592C60.4382 49.2541 60.3927 49.0757 60.3547 48.9238C60.3167 49.0757 60.2674 49.2655 60.2066 49.4933C60.1535 49.7136 60.1003 49.9262 60.0472 50.1312C60.0016 50.3286 59.9636 50.4691 59.9332 50.5527L58.3955 55.8265H56.5382Z",
    fill: "#E9688A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2361 55.8265H64.5341V54.8469L65.5251 54.3913V49.1288L64.5341 48.6732V47.6936H68.2361V48.6732L67.2451 49.1288V54.3913L68.2361 54.8469V55.8265Z",
    fill: "#E9688A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1601 55.8265H74.2009L72.0709 52.3979L71.3419 52.9219V55.8265H69.622V47.6936H71.3419V51.4183C71.4558 51.2589 71.5697 51.0994 71.6836 50.9399C71.7975 50.7805 71.9115 50.621 72.0254 50.4615L74.2237 47.6936H76.1373L73.3011 51.293L76.1601 55.8265Z",
    fill: "#E9688A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9126 55.5645V54.5393C76.9126 54.3495 77.0037 54.2546 77.186 54.2546H78.1883C78.2643 54.2546 78.325 54.2812 78.3706 54.3343C78.4237 54.3875 78.4503 54.4558 78.4503 54.5393V55.5645C78.4503 55.7391 78.363 55.8265 78.1883 55.8265H77.186C77.1024 55.8265 77.0341 55.8037 76.9809 55.7581C76.9354 55.705 76.9126 55.6404 76.9126 55.5645ZM76.8898 47.5H78.4959L78.325 53.5939H77.0265L76.8898 47.5Z",
    fill: "#E9688A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 35H76C85.3888 35 93 42.6112 93 52C93 60.7315 86.4173 67.9255 77.9439 68.8901C77.7992 70.0304 77.3802 71.0851 76.755 71.986C87.4509 71.589 96 62.7929 96 52C96 40.9543 87.0457 32 76 32H32V48C32 61.2548 42.7452 72 56 72H65.2547C64.6444 71.125 64.2288 70.1041 64.0709 69H56C44.402 69 35 59.598 35 48V35Z",
    fill: "#E9688A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.005 74.3287C65.6374 73.2063 64 70.7944 64 68C64 64.134 67.134 61 71 61C74.866 61 78 64.134 78 68C78 70.7944 76.3626 73.2063 73.995 74.3287",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68 85C68 83.343 66.657 82 65 82C63.343 82 62 83.343 62 85V92C62 100.284 68.716 107 77 107C85.284 107 92 100.284 92 92V85C92 83.343 90.657 82 89 82C87.343 82 86 83.343 86 85V83C86 81.343 84.657 80 83 80C81.343 80 80 81.343 80 83V81C80 79.343 78.657 78 77 78C75.343 78 74 79.343 74 81V69C74 67.343 72.657 66 71 66C69.343 66 68 67.343 68 69V91V85Z",
    stroke: "#E9688A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.6570cd9260df2c2310fc45aaa7ebfce5.svg";
export { ForwardRef as ReactComponent };